"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-bitwise
const maxAcct = 1 << 23;
// eslint-disable-next-line no-bitwise
const maxSeq = 1 << 20;
// this (lossily) encodes the two pieces of info (uint64) needed to sign into
// one (53-bit) number. Cross your fingers.
function accountToNonce(accountNumber, sequence) {
    // we allow 23 bits (8 million) for accounts, and 20 bits (1 million) for tx/account
    // let's fix this soon
    if (accountNumber > maxAcct) {
        throw new Error("Account number is greater than 2^23, must update Nonce handler");
    }
    if (sequence > maxSeq) {
        throw new Error("Sequence is greater than 2^20, must update Nonce handler");
    }
    const val = accountNumber * maxSeq + sequence;
    return val;
}
exports.accountToNonce = accountToNonce;
// this extracts info from nonce for signing
function nonceToAccountNumber(nonce) {
    const acct = nonce / maxSeq;
    if (acct > maxAcct) {
        throw new Error("Invalid Nonce, account number is higher than can safely be encoded in Nonce");
    }
    return Math.round(acct);
}
exports.nonceToAccountNumber = nonceToAccountNumber;
// this extracts info from nonce for signing
function nonceToSequence(nonce) {
    const seq = nonce % maxSeq;
    return Math.round(seq);
}
exports.nonceToSequence = nonceToSequence;
//# sourceMappingURL=types.js.map